module.exports = __webpack_public_path__ + "static/media/badgeAndroid@3x.f5e134e8.png";